export default {"src":"/_next/static/media/mail.94e0eca7.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};